import { IStandardRatesOfPenetration } from '../../interfaces/istandard-rates-of-penetration';
import { AssetTeam } from '../asset-team';
import { PhaseStepType } from '../phase-step-type';

export class StandardRatesOfPenetrationBase {
  StandardRatesOfPenetrationId: number;
  AssetTeamId: number;
  RateOfPenetrationFeetPerDay: number;
  PhaseStepTypeId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AssetTeam?: AssetTeam;
  PhaseStepType?: PhaseStepType;

  constructor(item?: IStandardRatesOfPenetration) {
    if (item) {

      this.StandardRatesOfPenetrationId = item.StandardRatesOfPenetrationId;
      this.AssetTeamId = item.AssetTeamId;
      this.RateOfPenetrationFeetPerDay = item.RateOfPenetrationFeetPerDay;
      this.PhaseStepTypeId = item.PhaseStepTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.PhaseStepType = new PhaseStepType(item.PhaseStepType);
    }
  }
}